import { createTheme } from '@mui/material/styles';
import { ACCENT_COLOR } from '@/constants/colors';

/**
 * MUI theme for OptiBush — enterprise internal tool used by 2 000+ engineers.
 *
 * Design tokens:
 *  - Primary accent: #5e503f (warm brown, carried over from original Voila app)
 *  - Dense component sizing: suitable for data-heavy engineering UI
 *  - Roboto font at comfortable reading sizes
 */
const muiTheme = createTheme({
  palette: {
    primary: {
      main: ACCENT_COLOR, // #5e503f
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff7f0e', // vivid orange (matches GENERATED_SAMPLE_COLOR)
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#ecca0d',
    },
    info: {
      main: '#1976d2',
    },
    success: {
      main: '#2d9732d0',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },

  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 13, // slightly denser for engineering UI
    h6: {
      fontWeight: 700,
      fontSize: '1.05rem',
    },
    body2: {
      fontSize: '0.8125rem',
    },
    button: {
      textTransform: 'none', // sentence case buttons
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 8,
  },

  components: {
    MuiCard: {
      defaultProps: { elevation: 4 },
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#1976d2',
          },
        },
      },
    },

    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },

        contained: {
          color: '#ffffff', // ✅ force white text globally

          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 1)', // ✅ disabled state
          },
        },
      },
    },

    MuiFab: {
      styleOverrides: {
        sizeSmall: {
          width: 28,
          height: 28,
          minHeight: 28,
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        enterDelay: 400,
      },
    },
    MuiDialog: {
      defaultProps: {
        PaperProps: { elevation: 6 },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { borderRadius: 4 },
      },
    },
  },
});

export default muiTheme;
